<template>
  <div>
    <b-button @click="goToRoute" class="m-0 col-12 btn-step" variant="primary" squared>
      {{titleFooter}}
      <b-icon-arrow-left v-if="!killCheckIn && !finish" class="left" aria-hidden="true"/>
    </b-button>
    <loading-overlay :active="isLoading" :is-full-page="true" />
  </div>
</template>

<script>
export default {
  name: 'checkinfooterEnd',
  props: {
    titleFooter: String,
    killCheckIn: Boolean,
    finish: Boolean,
  },
  data(){
    return {
      isLoading: false
    }
  },
  methods: {
    goToRoute(){
      this.isLoading = true
      if(this.finish){
        this.isLoading = false
        this.$router.push('/login')
      }else if(this.killCheckIn){
        this.isLoading = false
        // localStorage.removeItem('resToken')
        // localStorage.removeItem('idNewGuest')
        localStorage.removeItem('termsandconditions')
        this.$router.push('/thanks')
      }else{
        this.$router.back()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
